import { createFileRoute } from '@tanstack/react-router';
import { KpiManagementModule } from '@/modules/kpi/kpi-management';

export const Route = createFileRoute('/(dashboard)/_dashboard/performance-review/')({
  component: KpiManagementModule,
});
